/* unplugin-vue-components disabled */import { render } from "./KilaKilaAdminMenu.vue?vue&type=template&id=0f480e5a&scoped=true"
import script from "./KilaKilaAdminMenu.vue?vue&type=script&lang=js"
export * from "./KilaKilaAdminMenu.vue?vue&type=script&lang=js"

import "./KilaKilaAdminMenu.vue?vue&type=style&index=0&id=0f480e5a&lang=less&scoped=true"

import exportComponent from "/Users/zhaoxu/Documents/development.localized/public.localized/github/KilaKila-Blog/kilakila-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f480e5a"]])

export default __exports__